import React, { useState } from "react";
import api from "../lib/api";
import { PageTitle } from "../components/Layout";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";
import * as Icons from "lucide-react";
import { PasswordRules, isValidPassword } from "./ResetPassword";

export default function SettingsPage() {
  const { user } = useAuth();
  const [f, setF] = useState({ current_password: "", new_password: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!isValidPassword(f.new_password)) return toast.error("Le mot de passe doit contenir au moins 8 caractères, dont une majuscule et un symbole.");
    if (f.new_password !== f.confirm) return toast.error("Les mots de passe ne correspondent pas");
    setSaving(true);
    try {
      await api.post("/me/password", { current_password: f.current_password, new_password: f.new_password });
      toast.success("Mot de passe mis à jour");
      setF({ current_password: "", new_password: "", confirm: "" });
    } catch (e2) { toast.error(e2.response?.data?.detail || "Échec de la mise à jour"); }
    finally { setSaving(false); }
  };

  return (
    <div className="max-w-2xl">
      <PageTitle overline="Mon espace" title="Paramètres" />

      <div className="bg-sable rounded-sm border border-marine/10 shadow-sm p-6 mb-8" data-testid="settings-account">
        <div className="flex items-center gap-2 mb-4"><h2 className="font-display text-xl text-marine">Compte</h2></div>
        <div className="text-sm text-marine space-y-1">
          <div className="flex items-center gap-2"><Icons.User size={16} className="text-marine" /> {user.name}</div>
          <div className="flex items-center gap-2"><Icons.Mail size={16} className="text-marine" /> {user.email}</div>
          <div className="flex items-center gap-2"><Icons.Shield size={16} className="text-marine" /> {user.role === "admin" ? "Agence" : user.role === "collaborator" ? "Collaborateur" : "Entreprise"}</div>
        </div>
      </div>

      <div className="bg-sable rounded-sm border border-marine/10 shadow-sm p-6" data-testid="settings-password">
        <div className="flex items-center gap-2 mb-4"><h2 className="font-display text-xl text-marine">Changer le mot de passe</h2></div>
        <form onSubmit={submit} className="space-y-4">
          <label className="text-sm block">Mot de passe actuel<input type="password" value={f.current_password} onChange={(e) => setF({ ...f, current_password: e.target.value })} data-testid="settings-current-password" className="inp mt-1" required /></label>
          <label className="text-sm block">Nouveau mot de passe<input type="password" value={f.new_password} onChange={(e) => setF({ ...f, new_password: e.target.value })} data-testid="settings-new-password" className="inp mt-1" required /></label>
          <PasswordRules value={f.new_password} />
          <label className="text-sm block">Confirmer le nouveau mot de passe<input type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="settings-confirm-password" className="inp mt-1" required /></label>
          <div className="flex justify-end"><button disabled={saving} data-testid="settings-password-save" className="bg-marine text-white rounded-sm px-5 py-2 text-sm hover:bg-marine-hover transition-colors disabled:opacity-50">{saving ? "Enregistrement…" : "Mettre à jour"}</button></div>
        </form>
      </div>
    </div>
  );
}
